export const removeFromArray = <T>(index: number, sourceArray: Array<T>): Array<T> => {
  if (!sourceArray) return [];
  if (index < 0) return [];
  if (sourceArray.length === 1) return [];
  return [...sourceArray.slice(0, index), ...sourceArray.slice(index + 1)];
};

export const containsAny = (array1?: any[], array2?: any[]) => array1?.some((val) => array2?.indexOf(val) !== -1);
